<template>
  <Loader v-if="loading" />
  <div class="notFound" v-else-if="!items.length">کلاسی یافت نشد!</div>
  <div v-else class="main">
    <div v-for="(item, index) in items" :key="index" class="rows" :style="index === 0 ? 'padding-top: 0' : 'padding-top: 20px'">
      <div class="right">
        <div class="title">{{ item.title }}</div>
        <div class="sub">{{ item.sessionTitle }}</div>
      </div>
      <div class="middle">
        <div class="date">تاریخ {{ convertDate(item.date) }}</div>
        <div class="hour">ساعت {{ convertM2HM(item.hour) }}</div>
      </div>
      <div class="left" @click="adminLogin(item)">
        <div class="login">ورود به کلاس</div>
      </div>
    </div>
  </div>
</template>

<script>
import dadbanCourseProvider from '../../../services/dadban/course'
import moment from 'jalali-moment'
import Loader from '../../widgets/loader.vue'
export default {
  data() {
    return {
      items: [],
      loading: false,
    }
  },
  mounted() {
    this.fetchClassList()
  },
  methods: {
    async fetchClassList() {
      this.loading = true
      const req = await dadbanCourseProvider.getAdminClassList(this.$route.params.courseId)
      this.items = req.data.data.output
      this.loading = false
    },
    convertDate(date) {
      let finalTime = moment(date).locale('fa').format('YYYY/M/D')
      return finalTime
    },
    convertM2HM(min) {
      const minutes = min % 60
      const hours = Math.floor(min / 60)
      return `${hours}:${minutes}`
    },
    async adminLogin(item) {
      this.loading = true
      const req = await dadbanCourseProvider.generateLoginUrl({
        courseSessionFileId: item.id,
        courseSessionId: item.sessionId,
        courseId: +this.$route.params.courseId,
      })
      this.loading = false
      window.open(req.data.data.loginUrl, '_blank')
    },
  },
  components: { Loader },
}
</script>

<style lang="scss" scoped>
$d-bule: #1d3fa8;
.rows {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #ced4da;
  .title {
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .sub {
    font-size: 12px;
  }
  .middle {
    display: flex;
    .date,
    .hour {
      margin-left: 5px;
      color: $d-bule;
      position: relative;
      top: 25px;
    }
  }
  .login {
    border: 1px solid $d-bule;
    border-radius: 4px;
    padding: 5px 10px;
    color: $d-bule;
    position: relative;
    top: 15px;
    cursor: pointer;
    &:hover {
      background: $d-bule;
      color: #fff;
    }
  }
}

.notFound {
  display: grid;
  place-items: center;
  font-size: 18px;
  height: 300px;
}
</style>
